var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-navbars-container"},[_c('div',{staticClass:"layout-navbars-breadcrumb-index hj-gf-content"},[_c('Logo'),_c('Menu'),_c('User')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }